import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { ChevronRightSolidIcon } from '@compono/ui-icons';
import '../SelectLegacy.js';
import 'react/jsx-runtime';
import '../../Button/Button.js';
import '../../Button/ButtonBase/index.js';
import '../../Button/ButtonBody/index.js';
import '../../Dropdown/DropdownProvider.js';
import '../SelectLegacyProvider.js';
import '../../Box/index.js';
import '../SelectLegacyDropdown.js';
import { SelectLegacyDropdownOption } from '../SelectLegacyDropdownOption.js';
import { SelectLegacyDropdownOptions } from '../SelectLegacyDropdownOptions.js';
import '../../Tag/TagIcon.js';
import '../../Tag/TagLabel.js';
import '../../Selectable/Selectable.js';
import '../../Selectable/SelectableOptions.js';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import 'react';
import 'crypto-js/md5';
import '../../Selectable/SelectableProvider.js';
import 'assert';
import 'react-keyed-flatten-children';
import 'cuid';
import '../../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import '@xstate/react';
import '../../Selectable/stateMachine/stateMachine.js';
import '../../Selectable/stateMachine/actionsMultiple.js';
import '../../Selectable/stateMachine/actionsSelectActive.js';
import '../SelectLegacySection.js';

var MultiLevelSelectLegacyOptions = function (props) {
    return (jsx(SelectLegacyDropdownOptions, __assign({ sx: { height: "100%", overflow: "auto" } }, props, { children: function (option) {
            var decor = option.hasChildOptions ? (jsx(ChevronRightSolidIcon, {})) : undefined;
            return (jsx(SelectLegacyDropdownOption, { sx: { "[data-icon]": { color: "black.60" } }, option: option, decor: decor }));
        } })));
};
MultiLevelSelectLegacyOptions.displayName = "MultiLevelSelectLegacyOptions";

export { MultiLevelSelectLegacyOptions };
//# sourceMappingURL=MultiLevelSelectLegacyOptions.js.map
